export const about = {
  label: 'Unternehmen',
  title: 'Zweck & Grundsätze',
  purpose: {
    title: 'Zweck der Holding',
    content: 'Halten und Verwalten von Beteiligungen im eigenen Namen und auf eigene Rechnung, nicht als Dienstleistung für Dritte, sowie Verwaltung eigenen Vermögens. Die DR Group GmbH ist eine Beteiligungsgesellschaft, die keine operativen Dienstleistungen erbringt.'
  },
  principles: {
    title: 'Grundsätze',
    content: 'Wir verfolgen eine langfristige Strategie bei der Auswahl und Verwaltung unserer Beteiligungen. Unsere Entscheidungen basieren auf sorgfältiger Analyse und klaren Governance-Strukturen.'
  },
  governance: {
    title: 'Governance',
    content: 'Klare Trennung zwischen Holding-Ebene und operativen Beteiligungen. Die Holding übernimmt Eigentümerschaft, Kapitalallokation und Governance, während die Beteiligungen eigenständig operativ tätig sind.'
  },
  separation: {
    title: 'Rollentrennung',
    holdco: {
      label: 'HoldCo',
      items: [
        'Eigentümerschaft',
        'Kapitalallokation',
        'Governance'
      ]
    },
    participations: {
      label: 'Beteiligungen',
      items: [
        'Operative Tätigkeit',
        'Vertragsabschlüsse',
        'Leistungserbringung'
      ]
    }
  }
};